import { ReviewAnalysisSentiment, ReviewAnalysisTag } from ':constants/reviews';
import { isNotNil } from ':helpers/type-checkers';
import { REVIEW_PUBLIC_BUSINESS_ID_SEPARATOR } from ':modules/reviews/constants';
import { isDateAfterNewSemanticAnalysisMinDate } from ':modules/semantic-analysis';

export function getSegmentsForSemanticAnalysisStats(reviews) {
    return reviews.flatMap((review) => {
        const reviewDate = review.socialCreatedAt ?? review.createdAt;
        const isAfterNewSemanticAnalysis = isDateAfterNewSemanticAnalysisMinDate(reviewDate);

        if (isAfterNewSemanticAnalysis) {
            return review.semanticAnalysisSegments.filter(
                (segmentAnalyse) =>
                    segmentAnalyse.tag !== ReviewAnalysisTag.OVERALL_EXPERIENCE &&
                    segmentAnalyse.sentiment !== ReviewAnalysisSentiment.NEUTRAL
            );
        }
        return review.semanticAnalysis?.segmentAnalyses
            .map(({ tag, sentiment, segment }) => ({
                category: tag,
                sentiment,
                segment,
            }))
            .filter(isNotNil)
            .filter(
                (segmentAnalyse) =>
                    segmentAnalyse.category !== ReviewAnalysisTag.OVERALL_EXPERIENCE &&
                    segmentAnalyse.sentiment !== ReviewAnalysisSentiment.NEUTRAL
            );
    });
}

export function getPositiveAndNegativeStatsForSemanticAnalysis(segments: { sentiment: string }[]) {
    const positiveSentimentsCount = segments.filter((s) => s.sentiment === ReviewAnalysisSentiment.POSITIVE).length;
    const negativeSentimentsCount = segments.filter((s) => s.sentiment === ReviewAnalysisSentiment.NEGATIVE).length;
    const positiveSentimentsPercentage = Math.round((positiveSentimentsCount * 100) / segments.length);
    const negativeSentimentsPercentage = Math.round((negativeSentimentsCount * 100) / segments.length);

    return {
        positiveSentimentsCount,
        positiveSentimentsPercentage,

        negativeSentimentsCount,
        negativeSentimentsPercentage,
    };
}

export function getNumberFromPublicBusinessId(publicBusinessId: string | null): string | null {
    if (!publicBusinessId) {
        return null;
    }
    return publicBusinessId.split(REVIEW_PUBLIC_BUSINESS_ID_SEPARATOR)[1] || null;
}

export function isLinkFromWheelOfFortune(link?: string): boolean {
    if (!link) {
        return false;
    }
    return link.includes('wheel-of-fortune');
}
